import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const InboxSession = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M19.3223 9.18994V4.68994C19.3223 4.39157 19.2037 4.10542 18.9928 3.89445C18.7818 3.68347 18.4956 3.56494 18.1973 3.56494H4.69727C4.3989 3.56494 4.11275 3.68347 3.90177 3.89445C3.69079 4.10542 3.57227 4.39157 3.57227 4.68994V17.0649C3.57227 17.3633 3.69079 17.6495 3.90177 17.8604C4.11275 18.0714 4.3989 18.1899 4.69727 18.1899H9.19727"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.57227 6.93994H19.3223"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9451 20.4399C18.4303 20.4399 20.4451 18.4252 20.4451 15.9399C20.4451 13.4547 18.4303 11.4399 15.9451 11.4399C13.4598 11.4399 11.4451 13.4547 11.4451 15.9399C11.4451 18.4252 13.4598 20.4399 15.9451 20.4399Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.9341 15.9399H15.9451V13.9517"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
